// extracted by mini-css-extract-plugin
export default {"root":"Label-root-010b41691b425b0efbe28bc772c32ea9"};